/**
 * Builds a redirect URL for the unified redirect route
 *
 * @param iri - The IRI of the resource (e.g., '/material_bookings/123', '/circles/my-circle')
 * @param action - Optional action to perform (default: 'view')
 * @param extraParams - Optional query params (e.g. invitationId for network join review)
 * @returns The redirect URL (e.g., '/redirect?iri=%2Fmaterial_bookings%2F123&action=view')
 *
 * @example
 * buildRedirectUrl('/material_bookings/123', 'view')
 * // => '/redirect?iri=%2Fmaterial_bookings%2F123&action=view'
 *
 * buildRedirectUrl('/circles/my-circle', 'dashboard')
 * // => '/redirect?iri=%2Fcircles%2Fmy-circle&action=dashboard'
 */
export function buildRedirectUrl(
  iri: string,
  action: string = 'view',
  extraParams?: Record<string, string>
): string {
  const params = new URLSearchParams()
  params.set('iri', iri)
  params.set('action', action)
  if (extraParams) {
    for (const [key, value] of Object.entries(extraParams)) {
      if (value !== '' && value != null) {
        params.set(key, value)
      }
    }
  }
  return `/redirect?${params.toString()}`
}
